/**
 * @author Ketan Shetye
 * @created 2025-11-03
 * @description constants centralisation
 */

export const applicantHomeRoutesNames = {
  root: 'applicant-home',
  applyForPermit: {
    route: 'apply-for-permit',
    laptopDisplay: 'Apply for Permit',
    mobileDisplay: 'APPLY'
  },
  //added by priya 03-12-2025
  application: {
    route: 'application'
  },
  childApplication: {
    route: 'child-application'
  },
  contact: {
    route: 'contact',
    laptopDisplay: 'Contact',
    mobileDisplay: 'CONTACT'
  },
  editProfile: {
    route: 'edit-profile',
    laptopDisplay: 'Edit Profile',
    mobileDisplay: 'PROFILE'
  },
  changePassword: {
    route: 'change-password',
    laptopDisplay: 'CHANGE PASSWORD',
    mobileDisplay: 'CHANGE PASSWORD'
  },
  //end by priya 03-12-2025

  myApplications: {
    route: 'my-applications',
    laptopDisplay: 'My Applications',
    mobileDisplay: 'My APPS'
  },
  // Added by amisha on 05/21/2026
  myRenewals: {
    route: 'my-renewals',
    laptopDisplay: 'My Renewals',
    mobileDisplay: 'RENEWALS'
  },
  faq: {
    route: 'faq',
    laptopDisplay: 'FAQ',
    mobileDisplay: 'FAQ'
  },

  // added by juber 24-05-2026
  myContractorRegistrations: {
    route: 'my-contractor-registrations',
    laptopDisplay: 'Contractors',
    mobileDisplay: 'CONTRACTORS'
  }
  // added by juber 24-05-2026
};
